import script from "./DemandDayCutoff.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandDayCutoff.vue?vue&type=script&setup=true&lang=ts"

import "./DemandDayCutoff.vue?vue&type=style&index=0&id=3a27b39c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a27b39c"]])

export default __exports__